import {
    createSkyNetDomainRoutes,
} from 'app/PoC/DataGridDemoPages/SkyNetDomainV2/SkyNetDomain.utils'
import ActivityRecordsDemoPage from 'app/PoC/DataGridDemoPages/ActivityRecordsDemo/ActivityRecordsDemoPage'
import domainConfig from './ActivityRecordDemo.config'

export default createSkyNetDomainRoutes(<ActivityRecordsDemoPage />, domainConfig)
